'use client';

import { memo } from 'react';

import { Alignable, Headline, HeadlineLevel, HeadlineMarkup, View } from '@bytel/trilogy-react-ts';

import { SSIBlock } from '@components/ssi-block';

const faqStyles = `
    .faq-container {
        position: relative;
    }

    .faq-container .faq-toggle {
        display: none;
    }

    .faq-container .articles-wrapper article:nth-child(n + 6) {
        display: none;
    }

    .faq-container .faq-toggle:checked ~ .faq-show-more-trigger {
        display: none;
    }

    .faq-container .faq-toggle:checked ~ .articles-wrapper article {
        display: block;
    }

    .articles-wrapper:has(article:nth-child(-n+5):last-child) + .faq-show-more-trigger {
        display: none;
    }
`;
function FaqComponent({ isMobilePlan }: Readonly<{ isMobilePlan: boolean }>) {
    return (
        <>
            <style>{faqStyles}</style>
            <div className='container is-fluid mb-5'>
                <Headline
                    className='has-text-centered has-text-blue-byou'
                    typo={Alignable.ALIGNED_CENTER}
                    markup={HeadlineMarkup.H2}
                    level={HeadlineLevel.LEVEL3}
                >
                    Vos questions fréquentes <br />
                    sur les {isMobilePlan ? 'forfaits' : 'offres'} B&YOU
                </Headline>

                {/* Mobile FAQ Section */}
                <View className={`faq-byou ${isMobilePlan ? '' : 'is-hidden'}`}>
                    <div className='faq-container'>
                        <input type='checkbox' id='faq-toggle-mobile' className='faq-toggle' />
                        <div className='articles-wrapper'>
                            <SSIBlock url='/partials/faq/emplacements/byou-pwa' tagId='faq-byou-pwa' />
                        </div>
                        <div className='has-text-centered mt-5 faq-show-more-trigger'>
                            <label htmlFor='faq-toggle-mobile' className='link'>
                                Voir les autres questions
                            </label>
                        </div>
                    </div>
                </View>
                {/* FAI FAQ Section */}
                <View className={`faq-pwa ${isMobilePlan ? 'is-hidden' : ''}`}>
                    <div className='faq-container'>
                        <input type='checkbox' id='faq-toggle-fai' className='faq-toggle' />
                        <div className='articles-wrapper'>
                            <SSIBlock url='/partials/faq/emplacements/byou-fai' tagId='faq-byou-fai' />
                        </div>
                        <div className='has-text-centered mt-5 faq-show-more-trigger'>
                            <label htmlFor='faq-toggle-fai' className='link'>
                                Voir les autres questions
                            </label>
                        </div>
                    </div>
                </View>
            </div>
        </>
    );
}

export const Faq = memo(FaqComponent);
